module.exports = __webpack_public_path__ + "static/media/map-marker-plus-outline.e66882eb.svg";